/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { getViajes, getAlertas, getHitosConfig, getEmpresa, getEmpresaById, crearAlerta, actualizarAlerta } from '../lib/db';
import { signOut } from '../lib/auth';
import Layout from '../components/Layout';
import Viajes from './Viajes';
import Alertas from './Alertas';
import Carriers from './Carriers';
import Clientes from './Clientes';
import Reportes from './Reportes';
import Configuracion from './Configuracion';
import Rutas from './Rutas';
import CRM from "./CRM";
import Tareas from "./Tareas";
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const ahora = new Date();
const hace20hrs = new Date(ahora - 20 * 60 * 60 * 1000).toISOString();

const viajesHistoricos = [];

const viajesIniciales = [];

const alertasIniciales = [];

const estadoColor = { moving: '#00e5a0', stopped: '#ef4444', idle: '#f59e0b' };
const estadoLabel = { moving: 'En movimiento', stopped: 'Detenida', idle: 'Descanso' };

function estadoUnidadDesdeHitos(hitos, hitosConfig) {
  if (!hitos || hitos.length === 0) return { label: 'Sin iniciar', color: '#6b7280' };
  const ultimo = hitos[hitos.length - 1].nombre;
  const config = hitosConfig?.find(h => h.nombre === ultimo);
  if (config?.color) return { label: ultimo, color: config.color };
  if (ultimo === 'Llegada a carga') return { label: 'Llegada a carga', color: '#8b5cf6' };
  if (ultimo === 'En tránsito') return { label: 'En tránsito', color: '#00e5a0' };
  if (ultimo === 'En movimiento') return { label: 'En movimiento', color: '#00e5a0' };
  if (ultimo === 'Descanso') return { label: 'Descanso', color: '#3b82f6' };
  if (ultimo === 'Detenida') return { label: 'Detenida', color: '#ef4444' };
  if (ultimo === 'Llegada a descarga') return { label: 'Llegada a descarga', color: '#f59e0b' };
  if (ultimo === 'Completado') return { label: 'Completado', color: '#00e5a0' };
  if (ultimo === 'En espera de determinaciones') return { label: 'En espera', color: '#f59e0b' };
  return { label: ultimo, color: '#6b7280' };
}
function esReciente(v) {
  if (v.estado === 'active') return true;
  if (!v.fechaCierre) return false;
  return (new Date() - new Date(v.fechaCierre)) / (1000 * 60 * 60) <= 48;
}

const iconVerde = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34],
});

const iconGris = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-grey.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34],
});

const iconRojo = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34],
});

const iconAmbar = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-gold.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34],
});

const posicionesMexico = [
  [19.4326, -99.1332],  // CDMX
  [25.6866, -100.3161], // MTY
  [20.6597, -103.3496], // GDL
  [19.0414, -98.2063],  // Puebla
  [22.1565, -100.9855], // SLP
  [29.0892, -110.9600], // Hermosillo
];

function MapaLeaflet({ viajes }) {
  const centro = [23.6345, -102.5528];

  const getIcon = (v) => {
    if (!v.link_gps && !v.linkGps) return iconGris;
    if (v.estadoUnidad === 'stopped') return iconRojo;
    if (v.estadoUnidad === 'idle') return iconAmbar;
    return iconVerde;
  };

  return (
    <MapContainer
      center={centro}
      zoom={5}
      style={{ height: '320px', width: '100%' }}
      zoomControl={true}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      />
      {viajes.map((v, i) => (
        <Marker
          key={v.id}
          position={posicionesMexico[i % posicionesMexico.length]}
          icon={getIcon(v)}
        >
          <Popup>
            <div style={{ minWidth: '180px', fontFamily: 'sans-serif' }}>
              <div style={{ fontWeight: '700', color: '#059669', fontSize: '14px', marginBottom: '6px' }}>{v.numero}</div>
              <div style={{ color: '#374151', fontSize: '12px', marginBottom: '2px' }}>{v.carrier}</div>
              <div style={{ color: '#6b7280', fontSize: '12px', marginBottom: '2px' }}>{v.ruta}</div>
              <div style={{ color: '#6b7280', fontSize: '12px', marginBottom: '10px' }}>{v.unidad || '—'} · {v.placas || '—'}</div>
              {(v.link_gps || v.linkGps) ? (
                <a
                  href={v.link_gps || v.linkGps}
                  target="_blank"
                  rel="noreferrer"
                  style={{ display: 'block', textAlign: 'center', background: '#2563eb', color: '#fff', borderRadius: '6px', padding: '7px 12px', fontSize: '12px', fontWeight: '700', textDecoration: 'none' }}
                >
                  Ver en Maps
                </a>
              ) : (
                <div style={{ textAlign: 'center', color: '#d97706', fontSize: '12px', fontWeight: '600' }}>Sin GPS enlazado</div>
              )}
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}

export default function Dashboard() {
  const [alerts, setAlerts] = useState(alertasIniciales);
  const [viajes, setViajes] = useState([]);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [viajePreseleccionado, setViajePreseleccionado] = useState(null);
  const [empresaId, setEmpresaId] = useState(null);
  const [empresa, setEmpresa] = useState({});
  const [notificacionesActivas, setNotificacionesActivas] = useState(true);
  const [prevAlertCount, setPrevAlertCount] = useState(0);
  const [minutosAlerta, setMinutosAlerta] = useState(() => {
    try { const s = localStorage.getItem('minutosAlerta'); return s ? parseInt(s) : 60; } catch { return 60; }
  });
  useEffect(() => { localStorage.setItem('minutosAlerta', minutosAlerta); }, [minutosAlerta]);
  const [hitos, setHitos] = useState([
    { id: 1, nombre: 'Llegada a carga', activo: true, fotos: false, aprobacion: 'manual', palabrasClave: 'llegada, llegué, estoy en bodega, en carga' },
    { id: 2, nombre: 'En tránsito', activo: true, fotos: false, aprobacion: 'auto', palabrasClave: 'saliendo, en tránsito, en camino, arrancando, ya salimos' },
    { id: 3, nombre: 'Descanso', activo: true, fotos: false, aprobacion: 'auto', palabrasClave: 'descansando, comiendo, parada para comer, dormimos' },
    { id: 4, nombre: 'Detenida', activo: true, fotos: false, aprobacion: 'manual', palabrasClave: 'parado, tráfico, falla, parada técnica, accidente' },
    { id: 5, nombre: 'Llegada a descarga', activo: true, fotos: true, aprobacion: 'manual', palabrasClave: 'llegué a destino, llegada a descarga, en destino' },
    { id: 6, nombre: 'Completado', activo: true, fotos: true, aprobacion: 'manual', palabrasClave: '' },
    { id: 7, nombre: 'En espera de determinaciones', activo: true, fotos: false, aprobacion: 'manual', palabrasClave: 'robo, accidente, siniestro, incidente, detenido por autoridades' },
  ]);

  useEffect(() => {
    const cargarDatos = async () => {
      const session = await getEmpresa();
      if (session?.empresa_id) {
        setEmpresaId(session.empresa_id);
        const { data: viajesDB } = await getViajes(session.empresa_id);
        const { data: alertasDB } = await getAlertas(session.empresa_id);
        const { data: hitosDB } = await getHitosConfig(session.empresa_id);
        const viajesCargados = viajesDB ? viajesDB.map(v => ({ ...v, hitos: v.hitos || [], gastos: v.gastos || [] })) : [];
        if (viajesDB) setViajes(viajesCargados);
        const { data: empData } = await getEmpresaById(session.empresa_id);
        if (empData) setEmpresa(empData);
        const alertasCargadas = alertasDB || [];
        if (alertasDB) setAlerts(alertasCargadas);
        if (hitosDB && hitosDB.length > 0) setHitos(hitosDB);
        
        // Revisar alertas con datos frescos
        const ahora = new Date();
        const nuevasAlertas = [];
        for (const v of viajesCargados.filter(v => v.estado === 'active')) {
          if (!v.hitos || v.hitos.length === 0) continue;
          const ultimoHito = v.hitos[v.hitos.length - 1];
          const hitos_sin_alerta = ['En tránsito', 'En movimiento'];
          if (hitos_sin_alerta.includes(ultimoHito.nombre)) continue;
          const fechaHito = ultimoHito.created_at ? new Date(ultimoHito.created_at) : null;
          if (!fechaHito || isNaN(fechaHito.getTime())) continue;
          const tiempoTranscurrido = (ahora - fechaHito) / 60000;
          if (tiempoTranscurrido < minutosAlerta) continue;
          const yaExiste = alertasCargadas.find(a => a.viaje_id === v.id && a.tipo === 'sin_actualizacion' && !a.dismissed);
          if (yaExiste) continue;
          const nuevaAlerta = {
            empresa_id: session.empresa_id,
            viaje_id: v.id,
            unidad: v.unidad || v.numero,
            caja: v.caja || null,
            conductor: v.conductor || '—',
            loc: ultimoHito.ubicacion || ultimoHito.nombre,
            mins: Math.floor(tiempoTranscurrido),
            tipo: 'sin_actualizacion',
            dismissed: false,
            motivo: '',
          };

          const { data, error } = await crearAlerta(nuevaAlerta);
          if (data) nuevasAlertas.push({ ...nuevaAlerta, id: data.id });
        }
        if (nuevasAlertas.length > 0) setAlerts(prev => [...prev, ...nuevasAlertas]);
      }
    };
    cargarDatos();
  }, []);

  useEffect(() => {
    const current = alerts.filter(a => !a.dismissed).length;
    if (notificacionesActivas && current > prevAlertCount) {
      try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)();
        const o = ctx.createOscillator();
        const g = ctx.createGain();
        o.connect(g); g.connect(ctx.destination);
        o.frequency.setValueAtTime(880, ctx.currentTime);
        o.frequency.setValueAtTime(660, ctx.currentTime + 0.1);
        g.gain.setValueAtTime(0.3, ctx.currentTime);
        g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
        o.start(ctx.currentTime);
        o.stop(ctx.currentTime + 0.4);
      } catch(e) {}
    }
    setPrevAlertCount(current);
  }, [alerts]);

useEffect(() => {
  if (activeTab === 'dashboard' && empresaId) {
    getViajes(empresaId).then(({ data }) => {
      if (data) setViajes(data.map(v => ({ ...v, hitos: v.hitos || [], gastos: v.gastos || [] })));
    });
  }
}, [activeTab]);
  const activeAlerts = alerts.filter(a => !a.dismissed).length;
  const unidadesActivas = viajes.filter(v => esReciente(v) && v.estado === 'active');
  const todosLosViajes = [...viajes];

  const hitosTransito = ['En tránsito', 'En movimiento'];
  const hitosDescanso = ['Descanso'];
  const hitosDetenida = ['Llegada a carga', 'Detenida', 'Llegada a descarga'];

  const kpis = [
    { label: 'En Movimiento', value: unidadesActivas.filter(v => { const u = v.hitos?.[v.hitos.length-1]?.nombre; return hitosTransito.includes(u); }).length, color: '#00e5a0' },
    { label: 'Detenidas', value: unidadesActivas.filter(v => { const u = v.hitos?.[v.hitos.length-1]?.nombre; return hitosDetenida.includes(u); }).length, color: '#ef4444' },
    { label: 'En Descanso', value: unidadesActivas.filter(v => { const u = v.hitos?.[v.hitos.length-1]?.nombre; return hitosDescanso.includes(u); }).length, color: '#f59e0b' },
    { label: 'Alertas Activas', value: activeAlerts, color: '#f59e0b' },
  ];

  const handleBusquedaSelect = (resultado) => {
    setViajePreseleccionado(resultado.viaje);
    setActiveTab(resultado.pantalla);
  };

  const renderDashboard = () => (
    <div style={{ padding: '28px 32px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px' }}>
        {kpis.map((kpi, i) => (
          <div key={i} style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '20px', borderTop: `2px solid ${kpi.color}` }}>
            <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', marginBottom: '10px' }}>{kpi.label}</div>
            <div style={{ fontSize: '38px', fontWeight: '700', color: kpi.color, lineHeight: 1 }}>{kpi.value}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 340px', gap: '16px', marginBottom: '24px', alignItems: 'start' }}>
        <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden', position: 'sticky', top: '60px' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730' }}>
            <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>Mapa en Tiempo Real</span>
          </div>
          <MapaLeaflet viajes={unidadesActivas} />
        </div>

        <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>Alertas Activas</span>
            <button onClick={() => setActiveTab('alertas')} style={{ fontSize: '11px', padding: '3px 10px', borderRadius: '4px', border: '1px solid #222730', background: 'transparent', color: '#6b7280', cursor: 'pointer' }}>Ver todas →</button>
          </div>
          <div style={{ overflow: 'auto', flex: 1 }}>
            {alerts.filter(a => !a.dismissed).map(a => (
              <div key={a.id} style={{ padding: '12px 16px', borderBottom: '1px solid #222730' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ fontFamily: 'monospace', fontSize: '12px', fontWeight: '600', color: '#f59e0b' }}>{a.unidad}{a.caja ? ` · Caja ${a.caja}` : ''}</span>
                  <span style={{ fontSize: '10px', color: '#6b7280' }}>{a.mins} min</span>
                </div>
                <div style={{ fontSize: '12px', color: '#e8eaf0', marginBottom: '8px' }}>{a.loc}</div>
                <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '6px' }}>Desactivar por:</div>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                  {['Tráfico', 'Descanso / Comida', 'Parada técnica', 'En carga / descarga', 'Otro'].map(motivo => (
                    <button key={motivo} onClick={() => { actualizarAlerta(a.id, { dismissed: true, motivo }); setAlerts(alerts.map(x => x.id === a.id ? { ...x, dismissed: true, motivo } : x)); }}
                      style={{ fontSize: '11px', padding: '3px 8px', borderRadius: '4px', border: 'none', background: 'rgba(245,158,11,0.15)', color: '#f59e0b', cursor: 'pointer', fontWeight: '600' }}>
                      {motivo}
                    </button>
                  ))}
                </div>
              </div>
            ))}
            {alerts.every(a => a.dismissed) && (
              <div style={{ padding: '24px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin alertas activas</div>
            )}
          </div>
        </div>
      </div>

      <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', overflow: 'hidden' }}>
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #222730' }}>
          <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>Unidades Activas</span>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {['Viaje', 'Cliente', 'Carrier', 'Ruta', 'Unidad', 'Caja', 'Estado', 'Ubicación'].map(h => (
                <th key={h} style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '2px', color: '#6b7280', padding: '12px 20px', textAlign: 'left', borderBottom: '1px solid #222730', fontWeight: '600' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {unidadesActivas.map((v, i) => (
              <tr key={v.id} onClick={() => { setViajePreseleccionado(v); setActiveTab('viajes'); }}
                style={{ background: i % 2 === 0 ? 'transparent' : '#0d1117', cursor: 'pointer' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,229,160,0.04)'}
                onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? 'transparent' : '#0d1117'}>
                <td style={{ padding: '12px 20px', fontFamily: 'monospace', fontSize: '12px', color: '#00e5a0' }}>{v.numero}</td>
                <td style={{ padding: '12px 20px', fontSize: '12px', color: '#9ca3af' }}>{v.cliente || '—'}</td>
                <td style={{ padding: '12px 20px', fontSize: '13px', color: '#e8eaf0' }}>{v.carrier}</td>
                <td style={{ padding: '12px 20px', fontSize: '12px', color: '#6b7280' }}>{v.ruta}</td>
                <td style={{ padding: '12px 20px', fontFamily: 'monospace', fontSize: '12px', color: '#e8eaf0' }}>{v.unidad || '—'}</td>
                <td style={{ padding: '12px 20px', fontSize: '12px', color: '#9ca3af' }}>{v.caja || '—'}</td>
                <td style={{ padding: '12px 20px' }}>
                  {(() => { const eu = estadoUnidadDesdeHitos(v.hitos, hitos); return (
                    <span style={{ display: 'inline-flex', alignItems: 'center', padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '600', background: `${eu.color}18`, color: eu.color }}>
                      {eu.label}
                    </span>
                  ); })()}
                </td>
                <td style={{ padding: '12px 20px' }}>
                  {v.linkGps || v.link_gps
                    ? <a href={v.linkGps || v.link_gps} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()} style={{ fontSize: '11px', color: '#3b82f6', textDecoration: 'none' }}>Ver GPS</a>
                    : <span style={{ fontSize: '11px', color: '#6b7280' }}>—</span>}
                </td>
              </tr>
            ))}
            {unidadesActivas.length === 0 && (
              <tr><td colSpan="8" style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin viajes activos</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <Layout activeTab={activeTab} setActiveTab={setActiveTab} alertCount={activeAlerts} viajes={todosLosViajes} alerts={alerts} onSelect={handleBusquedaSelect} hitos={hitos} notificacionesActivas={notificacionesActivas} setNotificacionesActivas={setNotificacionesActivas} onSignOut={async () => { await signOut(); window.location.reload(); }}>
      {activeTab === 'dashboard' && renderDashboard()}
      {activeTab === 'viajes' && <Viajes viajes={viajes} setViajes={setViajes} viajePreseleccionado={viajePreseleccionado} setViajePreseleccionado={setViajePreseleccionado} hitosConfig={hitos} empresaId={empresaId} empresa={empresa} />}
      {activeTab === 'alertas' && <Alertas alerts={alerts} setAlerts={setAlerts} minutosAlerta={minutosAlerta} setMinutosAlerta={setMinutosAlerta} />}
      {activeTab === 'carriers' && <Carriers empresaId={empresaId} />}
      {activeTab === 'clientes' && <Clientes empresaId={empresaId} />}
      {activeTab === 'reportes' && <Reportes viajePreseleccionado={viajePreseleccionado} setViajePreseleccionado={setViajePreseleccionado} alerts={alerts} viajesDB={viajes.filter(v => v.estado === 'completed')} empresaId={empresaId} empresa={empresa} />}
      {activeTab === 'configuracion' && <Configuracion hitos={hitos} setHitos={setHitos} empresaId={empresaId} />}
      {activeTab === 'rutas' && <Rutas empresaId={empresaId} />}
      {activeTab === 'tareas' && <Tareas empresaId={empresaId} />}
      {activeTab === 'crm' && <CRM empresaId={empresaId} />}
    </Layout>
  );
}
